import groq from 'groq';

export const AssetFragment = groq`
  asset->{
    ...,
    _id,
    _type,
    altText,
    description,
    metadata {
      dimensions {
        ...
      }
    }
  }
`;

export const ImageAssetFragment = groq`
  _type,
  ${AssetFragment}
`;

export const ImageComponentFragment = groq`
  ...select(
    defined(image) => {
      "image": image {
        ${ImageAssetFragment}
      },
      'imageRef': image
    },
    {"image": image}
  )
`;

export const PosterFragment = groq`
  poster {
    _type,
    ${ImageAssetFragment}
  }
`;
